import { render, staticRenderFns } from "./PaperKeyDialogue.vue?vue&type=template&id=d1b42b02&"
import script from "./PaperKeyDialogue.vue?vue&type=script&lang=js&"
export * from "./PaperKeyDialogue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports